import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  updateOrganizationalUnit(
    request: Boundaries["updateOrganizationalUnit"]["request"],
  ): void;
}

function useUpdateOrganizationalUnit(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isUpdateOrganizationalUnitRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isUpdateOrganizationalUnitRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isUpdateOrganizationalUnitRequestFailure,
    ),
    updateOrganizationalUnit: core.updateOrganizationalUnit,
  };
}

export { useUpdateOrganizationalUnit };
